export enum EOrderItemChargeType {
  Normal = 0,
  RodizioIncluded = 1,
  RodizioAccess = 2,
}
